import { useEffect, useRef, useState } from 'react'
import { useLocation, useNavigate } from 'react-router-dom'

import styled from 'styled-components'

import { selectDevice } from 'hooks/deviceInfo'
import { useSelector } from 'react-redux'
import { timerAlert } from 'util/util'

import { useSpring, animated, useTransition } from '@react-spring/web'

import NavigateButton from 'components/NavigateButton'

import SpeedImg from 'assets/img/speed/speed.png'
import ProductBg from 'assets/img/sps/bg202603.png'
import TitleHeritage from 'assets/img/sps/spsTitleHeritage.png'
import TitleTrail from 'assets/img/sps/spsTitleTrail.png'
import TitleExclusive from 'assets/img/sps/spsTitleExc.png'

import { apiSaveLog, apiSpsDefineList, apiThumbnailList } from 'api/api'
import Slider, { Settings } from 'react-slick'

const Container = styled.div`
	background-image: url(${ProductBg});
	background-size: cover;
	background-repeat: no-repeat;
	background-position: center;
	padding: 97px 60px 0 120px;
	position: relative;
`

const ItemContainer = styled.div`
	position: relative;
	background: rgba(255, 255, 255, 0.2);
	padding: 20px 40px;
	margin-top: 200px;
	width: 1029px;
	height: 810px;
	text-align: center;
	.titleContainer {
		display: flex;
	}
	.scroller {
		position: absolute;
		top: 100px;
		left: 60px;
		right: 60px;
		bottom: 40px;
		border: 1px solid red;
		white-space: nowrap;
		overflow-y: auto;
		overflow-x: hidden;
		-webkit-overflow-scrolling: touch;
		display: flex;
		flex-wrap: wrap;
		.scrollItem {
			width: 33.3333%;
			margin-bottom: 30px;
			padding: 20px 30px;
			img {
				max-width: 302px;
				max-height: 187px;
			}
		}
		&::-webkit-scrollbar {
			display: none;
		}
	}
`

const SubItemWrapper = styled.div`
	position: absolute;
	top: 235px;
	right: 50px;
	width: 726px;
	.titleContainer {
		display: flex;
	}
	.subItemContainer {
		position: relative;
		background: rgba(255, 255, 255, 0.2);
		padding: 20px 60px;
		height: 360px;
		text-align: center;
		&:first-child {
			margin-bottom: 50px;
		}
		.scroller {
			position: absolute;
			top: 120px;
			left: 60px;
			right: 60px;
			bottom: 40px;
			white-space: nowrap;
			overflow-x: auto;
			overflow-y: hidden;
			-webkit-overflow-scrolling: touch;
			display: flex;
			flex-wrap: wrap;
			flex-direction: column;
			.scrollItem {
				width: 240px;
				margin-right: 56px;
				border: 1px solid red;
				&:last-child {
					margin-right: 0;
				}
				img {
					max-width: 240px;
					max-height: 187px;
				}
			}
			&::-webkit-scrollbar {
				display: none;
			}
		}
	}
`

const Row = styled.div`
	position: absolute;
	background: rgba(255, 255, 255, 0.2);
	padding: 0;
	width: 580px;
	height: 980px;
	display: block;
	&.col1 {
		left: 120px;
		width: 290px;
	}
	&.col2 {
		left: 410px;
		width: 290px;
	}
	&.col3 {
		left: 700px;
		width: 290px;
	}
	&.col4 {
		left: 993px;
		width: 290px;
	}
	&.col5 {
		left: 1282px;
		width: 290px;
	}
	&.col6 {
		left: 1575px;
		width: 290px;
	}
	.titleContainer {
		img {
			max-height: 50px;
		}
	}
	.scroller {
		position: absolute;
		top: 0;
		left: 0;
		right: 0;
		bottom: 0;
		overflow: hidden;
		// overflow-y: auto;
		// display: flex;
		// flex-wrap: wrap;
		// flex-direction: column;
		.left {
			display: flex;
			justify-content: center;
			align-items: center;
			width: 100%;
			height: 100%;
		}
		.right {
			display: flex;
			justify-content: center;
			align-items: center;
			width: 100%;
			height: 100%;
		}
		.scrollItem {
			position: relative;
			width: 580px;
			height: 275px;
			display: flex !important;
			align-items: center;
			justify-content: center;
			img {
				max-width: 70%;
				max-height: auto;
				display: block;
				margin: auto;
			}
		}
		&::-webkit-scrollbar {
			display: none;
		}
	}
`

const SpsList = () => {
	const location = useLocation()
	const deviceInfo = useSelector(selectDevice)
	const navigate = useNavigate()

	const [spsDataList, setSpsDataList] = useState<any[]>([])

	const [vintageList1, setVintageList1] = useState<any>({})
	const [vintageList2, setVintageList2] = useState<any>({})
	const [vintageList3, setVintageList3] = useState<any>({})
	const [morderList4, setMorderList4] = useState<any>({})
	const [morderList5, setMorderList5] = useState<any>({})
	const [morderList6, setMorderList6] = useState<any>({})

	const sliderRef1 = useRef<Slider>(null)
	const sliderRef2 = useRef<Slider>(null)
	const sliderRef3 = useRef<Slider>(null)
	const sliderRef4 = useRef<Slider>(null)
	const sliderRef5 = useRef<Slider>(null)
	const sliderRef6 = useRef<Slider>(null)

	const getSliderSettings = (
		productList: any[] | undefined,
		sliderRef: React.RefObject<Slider | null>,
	): Settings => {
		const items =
			productList?.filter((item: any) => item.pdbkProductId === undefined) ?? []
		const totalItems = items.length
		const slidesToShow = 4
		const canScroll = totalItems > slidesToShow
		return {
			slidesToShow,
			autoplay: canScroll,
			dots: false,
			infinite: false,
			arrows: true,
			speed: 300,
			slidesToScroll: 1,
			autoplaySpeed: 5000,
			vertical: true,
			verticalSwiping: true,
			afterChange: canScroll
				? (currentSlide: number) => {
						if (currentSlide >= totalItems - slidesToShow) {
							setTimeout(() => {
								sliderRef.current?.slickGoTo(0)
							}, 5000)
						}
					}
				: undefined,
		}
	}

	const groupedItems = (list: any[], groupSize: number) => {
		let groupedImages = []
		for (let i = 0; i < list.length; i += groupSize) {
			groupedImages.push(list.slice(i, i + groupSize))
		}
		// 만약 groupedImages의 하위 array 중에 갯수가 홀수면 짝수로 맞춰줌
		groupedImages.forEach((element: any) => {
			if (element.length % 2 !== 0) {
				element.push({
					attachFileId: '',
					fileId: 0,
					fileName: '',
					name: 0,
					productId: 0,
				})
			}
		})

		console.log('groupedImages', groupedImages)
		return groupedImages
	}

	const onItemClick = (item: any, itemType: any) => {
		console.log(item)
		console.log(itemType)
		console.log(location.state?.item)
		// const { menuList } = location.state
		// let subsortId = 0
		if (vintageList1.productList?.includes(item)) {
			item = {
				...item,
				subsortId: vintageList1.subsortId,
				title: 'VINTAGE<br/>TECH',
			}
		} else if (vintageList2.productList?.includes(item)) {
			item = {
				...item,
				subsortId: vintageList2.subsortId,
				title: 'VINTAGE<br/>TECH',
			}
		} else if (vintageList3.productList?.includes(item)) {
			item = { ...item, subsortId: vintageList3.subsortId, title: 'MODERN' }
		} else if (morderList4.productList?.includes(item)) {
			item = { ...item, subsortId: morderList4.subsortId, title: 'MODERN' }
		} else if (morderList5.productList?.includes(item)) {
			item = {
				...item,
				subsortId: morderList5.subsortId,
				title: 'VISIBLE<br/>TECH',
			}
		} else if (morderList6.productList?.includes(item)) {
			item = { ...item, subsortId: morderList6.subsortId, title: 'CLASSIC' }
		}

		const logRequest = {
			userId: deviceInfo.userId,
			kioskDeviceId: deviceInfo.kioskDeviceId,
			categoryId: deviceInfo.categoryId,
			productId: item.productId,
			subSortId: item.subsortId,
		}
		console.log(logRequest)
		if (
			logRequest.userId &&
			logRequest.kioskDeviceId &&
			logRequest.categoryId &&
			logRequest.productId &&
			logRequest.subSortId
		) {
			apiSaveLog(logRequest)
		}

		navigate(`/sps/view`, { state: { item } })
	}

	const [isDragging, setIsDragging] = useState(false)

	const handleTouchStart = () => {
		setIsDragging(false)
	}

	const handleTouchMove = () => {
		setIsDragging(true)
	}

	const handleTouchEnd = (item: any, name: string) => {
		if (!isDragging) {
			// pageMove(menuList[index])
			onItemClick(item, name)
		}
		setIsDragging(false)
	} // onItemClick(subItem, '헤리티지')

	useEffect(() => {
		const { menuList } = location.state
		console.log(location.state)
		console.log(menuList)

		apiSpsDefineList({
			subsortId: location.state?.item?.subsortId,
			kioskDeviceId: deviceInfo.kioskDeviceId,
		}).then((res) => {
			console.log('SPS 정의 목록')
			console.log(res)
			setSpsDataList(res)
			res.forEach((element: any) => {
				if (element.seq === 1) {
					// element.productList 길이가 4 이상이면 slick 마지막 요소가 화면에 가려서 보이지 않는 현상이 있어서 빈 요소를 1개 추가한다.
					if (element.productList.length === 4) {
						element.productList.push({
							attachFileId: '',
							fileId: 0,
							fileName: '',
							name: 0,
							productId: 0,
						})
					}
					setVintageList1(element)
				} else if (element.seq === 2) {
					if (element.productList.length === 4) {
						element.productList.push({
							attachFileId: '',
							fileId: 0,
							fileName: '',
							name: 0,
							productId: 0,
						})
					}
					setVintageList2(element)
				} else if (element.seq === 3) {
					if (element.productList.length === 4) {
						element.productList.push({
							attachFileId: '',
							fileId: 0,
							fileName: '',
							name: 0,
							productId: 0,
						})
					}
					setVintageList3(element)
				} else if (element.seq === 4) {
					if (element.productList.length === 4) {
						element.productList.push({
							attachFileId: '',
							fileId: 0,
							fileName: '',
							name: 0,
							productId: 0,
						})
					}
					setMorderList4(element)
				} else if (element.seq === 5) {
					if (element.productList.length === 4) {
						element.productList.push({
							attachFileId: '',
							fileId: 0,
							fileName: '',
							name: 0,
							productId: 0,
						})
					}
					setMorderList5(element)
				} else if (element.seq === 6) {
					if (element.productList.length === 4) {
						element.productList.push({
							attachFileId: '',
							fileId: 0,
							fileName: '',
							name: 0,
							productId: 0,
						})
					}
					setMorderList6(element)
				}
			})
		})
		const disablePinchZoom = (e: any) => {
			if (e.touches.length > 1) {
				e.preventDefault()
			}
		}
		document.addEventListener('touchmove', disablePinchZoom, { passive: false })
		return () => {
			document.removeEventListener('touchmove', disablePinchZoom)
		}
	}, [])

	return (
		<Container className="container">
			<Row className="col1">
				<h2
					className="asics-sport-style-rg"
					style={{
						textAlign: 'center',
						fontSize: '42px',
						position: 'absolute',
						top: '-62px',
						right: '0',
						left: '0',
						lineHeight: '60px',
						color: '#515151',
					}}
				>
					{morderList5.cate}
				</h2>
				<Slider
					ref={sliderRef5}
					{...getSliderSettings(morderList5.productList, sliderRef5)}
					className="scroller"
				>
					{morderList5.productList
						?.filter((item: any) => item.pdbkProductId === undefined)
						.map((item: any, index: number) => {
							return (
								<div
									className="scrollItem"
									key={item.fileId}
								>
									{item.fileId !== 0 ? (
										<img
											src={`${process.env.REACT_APP_HOST}/file/view/id/${item.fileId}`}
											alt={item.name}
											// onClick={() => onItemClick(subItem, '헤리티지')}
											onTouchStart={handleTouchStart}
											onTouchMove={handleTouchMove}
											onTouchEnd={() => handleTouchEnd(item, '모던')}
											onMouseDown={handleTouchStart}
											onMouseMove={handleTouchMove}
											onMouseUp={() => handleTouchEnd(item, '모던')}
										/>
									) : (
										<></>
									)}
								</div>
							)
						})}
				</Slider>
			</Row>
			<Row className="col2">
				<h2
					className="asics-sport-style-rg"
					style={{
						textAlign: 'center',
						fontSize: '42px',
						position: 'absolute',
						top: '-62px',
						right: '0',
						left: '0',
						lineHeight: '60px',
						color: '#515151',
					}}
				>
					{vintageList1.cate}
				</h2>
				<Slider
					ref={sliderRef1}
					{...getSliderSettings(vintageList1.productList, sliderRef1)}
					className="scroller"
				>
					{vintageList1.productList
						?.filter((item: any) => item.pdbkProductId === undefined)
						.map((item: any, index: number) => {
							return (
								<div
									className="scrollItem"
									key={item.fileId}
								>
									{item.fileId !== 0 ? (
										<img
											src={`${process.env.REACT_APP_HOST}/file/view/id/${item.fileId}`}
											alt={item.name}
											// onClick={() => onItemClick(subItem, '헤리티지')}
											onTouchStart={handleTouchStart}
											onTouchMove={handleTouchMove}
											onTouchEnd={() => {
												if (item.fileId !== 0) {
													handleTouchEnd(item, '빈티지테크')
												}
											}}
											onMouseDown={handleTouchStart}
											onMouseMove={handleTouchMove}
											onMouseUp={() => {
												if (item.fileId !== 0) {
													handleTouchEnd(item, '빈티지테크')
												}
											}}
										/>
									) : (
										<></>
									)}
								</div>
							)
						})}
				</Slider>
			</Row>
			<Row className="col3">
				<h2
					className="asics-sport-style-rg"
					style={{
						textAlign: 'center',
						fontSize: '42px',
						position: 'absolute',
						top: '-62px',
						right: '0',
						left: '0',
						lineHeight: '60px',
						color: '#515151',
					}}
				>
					{vintageList2.cate}
				</h2>
				<Slider
					ref={sliderRef2}
					{...getSliderSettings(vintageList2.productList, sliderRef2)}
					className="scroller"
				>
					{vintageList2.productList
						?.filter((item: any) => item.pdbkProductId === undefined)
						.map((item: any, index: number) => {
							return (
								<div
									className="scrollItem"
									key={item.fileId}
								>
									{item.fileId !== 0 ? (
										<img
											src={`${process.env.REACT_APP_HOST}/file/view/id/${item.fileId}`}
											alt={item.name}
											// onClick={() => onItemClick(subItem, '헤리티지')}
											onTouchStart={handleTouchStart}
											onTouchMove={handleTouchMove}
											onTouchEnd={() => handleTouchEnd(item, '빈티지테크')}
											onMouseDown={handleTouchStart}
											onMouseMove={handleTouchMove}
											onMouseUp={() => handleTouchEnd(item, '빈티지테크')}
										/>
									) : (
										<></>
									)}
								</div>
							)
						})}
				</Slider>
			</Row>
			<Row className="col4">
				<h2
					className="asics-sport-style-rg"
					style={{
						textAlign: 'center',
						fontSize: '42px',
						position: 'absolute',
						top: '-62px',
						right: '0',
						left: '0',
						lineHeight: '60px',
						color: '#515151',
					}}
				>
					{vintageList3.cate}
				</h2>
				<Slider
					ref={sliderRef3}
					{...getSliderSettings(vintageList3.productList, sliderRef3)}
					className="scroller"
				>
					{vintageList3.productList
						?.filter((item: any) => item.pdbkProductId === undefined)
						.map((item: any, index: number) => {
							return (
								<div
									className="scrollItem"
									key={item.fileId}
								>
									{item.fileId !== 0 ? (
										<img
											src={`${process.env.REACT_APP_HOST}/file/view/id/${item.fileId}`}
											alt={item.name}
											// onClick={() => onItemClick(subItem, '헤리티지')}
											onTouchStart={handleTouchStart}
											onTouchMove={handleTouchMove}
											onTouchEnd={() => handleTouchEnd(item, '빈티지테크')}
											onMouseDown={handleTouchStart}
											onMouseMove={handleTouchMove}
											onMouseUp={() => handleTouchEnd(item, '빈티지테크')}
										/>
									) : (
										<></>
									)}
								</div>
							)
						})}
				</Slider>
			</Row>
			<Row className="col5">
				<h2
					className="asics-sport-style-rg"
					style={{
						textAlign: 'center',
						fontSize: '42px',
						position: 'absolute',
						top: '-62px',
						right: '0',
						left: '0',
						lineHeight: '60px',
						color: '#515151',
					}}
				>
					{morderList4.cate}
				</h2>
				<Slider
					ref={sliderRef4}
					{...getSliderSettings(morderList4.productList, sliderRef4)}
					className="scroller"
				>
					{morderList4.productList
						?.filter((item: any) => item.pdbkProductId === undefined)
						.map((item: any, index: number) => {
							return (
								<div
									className="scrollItem"
									key={item.fileId}
								>
									{item.fileId !== 0 ? (
										<img
											src={`${process.env.REACT_APP_HOST}/file/view/id/${item.fileId}`}
											alt={item.name}
											// onClick={() => onItemClick(subItem, '헤리티지')}
											onTouchStart={handleTouchStart}
											onTouchMove={handleTouchMove}
											onTouchEnd={() => handleTouchEnd(item, '모던')}
											onMouseDown={handleTouchStart}
											onMouseMove={handleTouchMove}
											onMouseUp={() => handleTouchEnd(item, '모던')}
										/>
									) : (
										<></>
									)}
								</div>
							)
						})}
				</Slider>
			</Row>
			<Row className="col6">
				<h2
					className="asics-sport-style-rg"
					style={{
						textAlign: 'center',
						fontSize: '42px',
						position: 'absolute',
						top: '-62px',
						right: '0',
						left: '0',
						lineHeight: '60px',
						color: '#515151',
					}}
				>
					{morderList6.cate}
				</h2>
				<Slider
					ref={sliderRef6}
					{...getSliderSettings(morderList6.productList, sliderRef6)}
					className="scroller"
				>
					{morderList6.productList
						?.filter((item: any) => item.pdbkProductId === undefined)
						.map((item: any, index: number) => {
							return (
								<div
									className="scrollItem"
									key={item.fileId}
								>
									{item.fileId !== 0 ? (
										<img
											src={`${process.env.REACT_APP_HOST}/file/view/id/${item.fileId}`}
											alt={item.name}
											// onClick={() => onItemClick(subItem, '헤리티지')}
											onTouchStart={handleTouchStart}
											onTouchMove={handleTouchMove}
											onTouchEnd={() => handleTouchEnd(item, '클래식')}
											onMouseDown={handleTouchStart}
											onMouseMove={handleTouchMove}
											onMouseUp={() => handleTouchEnd(item, '클래식')}
										/>
									) : (
										<></>
									)}
								</div>
							)
						})}
				</Slider>
			</Row>
			{/* <Row className="col2">
				<Slider
					{...settings}
					className="scroller"
				>
					{vintageList2.map((item: any, index: number) => {
						return (
							<div key={item.fileId}>
								<div className="scrollItem">
									{item.map((subItem: any, subIndex: number) => {
										return (
											<div
												key={subItem.fileId}
												className={`${subIndex % 2 === 0 ? 'left' : 'right'}`}
											>
												{subItem.fileId === 0 ? (
													<></>
												) : (
													<img
														src={`${process.env.REACT_APP_HOST}/file/view/id/${subItem.fileId}`}
														alt={subItem.name}
														// onClick={() => onItemClick(subItem, '트레일')}
														onTouchStart={handleTouchStart}
														onTouchMove={handleTouchMove}
														onTouchEnd={() => handleTouchEnd(subItem, '트레일')}
														onMouseDown={handleTouchStart}
														onMouseMove={handleTouchMove}
														onMouseUp={() => handleTouchEnd(subItem, '트레일')}
													/>
												)}
											</div>
										)
									})}
								</div>
							</div>
						)
					})}
				</Slider>
			</Row>
			<Row className="col3">
				<Slider
					{...settings}
					className="scroller exclusive"
				>
					{vintageList3.map((item: any, index: number) => {
						return (
							<div key={item.fileId}>
								<div className="scrollItem">
									{item.map((subItem: any, subIndex: number) => {
										return (
											<div
												key={subItem.fileId}
												className={`${subIndex % 2 === 0 ? 'left' : 'right'}`}
											>
												<img
													src={`${process.env.REACT_APP_HOST}/file/view/id/${subItem.fileId}`}
													alt={subItem.name}
													// onClick={() => onItemClick(subItem, '익스클루시브')}
													onTouchStart={handleTouchStart}
													onTouchMove={handleTouchMove}
													onTouchEnd={() => handleTouchEnd(subItem, '익스클루시브')}
													onMouseDown={handleTouchStart}
													onMouseMove={handleTouchMove}
													onMouseUp={() => handleTouchEnd(subItem, '익스클루시브')}
												/>
											</div>
										)
									})}
								</div>
							</div>
						)
					})}
				</Slider>
			</Row>
			<Row className="col4">
				<Slider
					{...settings}
					className="scroller exclusive"
				>
					{morderList4.map((item: any, index: number) => {
						return (
							<div key={item.fileId}>
								<div className="scrollItem">
									{item.map((subItem: any, subIndex: number) => {
										return (
											<div
												key={subItem.fileId}
												className={`${subIndex % 2 === 0 ? 'left' : 'right'}`}
											>
												<img
													src={`${process.env.REACT_APP_HOST}/file/view/id/${subItem.fileId}`}
													alt={subItem.name}
													// onClick={() => onItemClick(subItem, '익스클루시브')}
													onTouchStart={handleTouchStart}
													onTouchMove={handleTouchMove}
													onTouchEnd={() => handleTouchEnd(subItem, '익스클루시브')}
													onMouseDown={handleTouchStart}
													onMouseMove={handleTouchMove}
													onMouseUp={() => handleTouchEnd(subItem, '익스클루시브')}
												/>
											</div>
										)
									})}
								</div>
							</div>
						)
					})}
				</Slider>
			</Row>
			<Row className="col5">
				<Slider
					{...settings}
					className="scroller exclusive"
				>
					{morderList5.map((item: any, index: number) => {
						return (
							<div key={item.fileId}>
								<div className="scrollItem">
									{item.map((subItem: any, subIndex: number) => {
										return (
											<div
												key={subItem.fileId}
												className={`${subIndex % 2 === 0 ? 'left' : 'right'}`}
											>
												<img
													src={`${process.env.REACT_APP_HOST}/file/view/id/${subItem.fileId}`}
													alt={subItem.name}
													// onClick={() => onItemClick(subItem, '익스클루시브')}
													onTouchStart={handleTouchStart}
													onTouchMove={handleTouchMove}
													onTouchEnd={() => handleTouchEnd(subItem, '익스클루시브')}
													onMouseDown={handleTouchStart}
													onMouseMove={handleTouchMove}
													onMouseUp={() => handleTouchEnd(subItem, '익스클루시브')}
												/>
											</div>
										)
									})}
								</div>
							</div>
						)
					})}
				</Slider>
			</Row>
			<Row className="col6">
				<Slider
					{...settings}
					className="scroller exclusive"
				>
					{morderList6.map((item: any, index: number) => {
						return (
							<div key={item.fileId}>
								<div className="scrollItem">
									{item.map((subItem: any, subIndex: number) => {
										return (
											<div
												key={subItem.fileId}
												className={`${subIndex % 2 === 0 ? 'left' : 'right'}`}
											>
												<img
													src={`${process.env.REACT_APP_HOST}/file/view/id/${subItem.fileId}`}
													alt={subItem.name}
													// onClick={() => onItemClick(subItem, '익스클루시브')}
													onTouchStart={handleTouchStart}
													onTouchMove={handleTouchMove}
													onTouchEnd={() => handleTouchEnd(subItem, '익스클루시브')}
													onMouseDown={handleTouchStart}
													onMouseMove={handleTouchMove}
													onMouseUp={() => handleTouchEnd(subItem, '익스클루시브')}
												/>
											</div>
										)
									})}
								</div>
							</div>
						)
					})}
				</Slider>
			</Row> */}
		</Container>
	)
}

export default SpsList
